import { Link, Drawer, makeStyles, IconButton } from '@material-ui/core';
import * as React from 'react';
import { useHistory } from 'react-router';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { PlanEatUserContext } from '../../config/Context';
import { MdClose } from 'react-icons/md';

const useStyles = makeStyles((theme: any) => ({
    container:{
        display: "flex",
        flexDirection: 'column',
        justifyContent: "space-between",
        alignItems: "end",
        width: "100%",
        height: "100%",
        padding: 25,
    },
    sideNavContainer: {
        flexDirection: 'column',
        justifyContent: "end",
        width: 250,
        height: "80%",
        backgroundColor: 'white',
        marginTop: 0,
        alignItems: 'end'
    },
    closeIconStyle: {
        color: "black",
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        width: '100%',
        marginBottom: 30
    },
    menuItemText: {
        fontSize: 24,
        color: 'black !important',
        fontWeight: 700,
    },
    menuItem: {
        marginTop: 25,
        justifyContent: 'end',
        display: 'flex',
    },
    oneItemRow: {
        paddingTop: 20,
        display: 'flex',
        gridTemplateColumns: '100%',
        gridTemplateRow: '100%'
    },
    buttonContainer: {
        fontSize: 17,
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '25px',
        color: 'red',
        justifyContent: 'start',
        marginLeft: 30,
        marginRight: 30
    },
    logoutText: {
        fontSize: 24,
        color: '#B00020 !important',
        fontWeight: 700,
        cursor: "pointer",
        "&:hover" :{
            color: "#FF1E1E !important",
        }
    },
}));


interface Props {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<any>>;
};

export const HamburgerMenu: React.FC<Props> = ({ open, setOpen }) => {
    const classes = useStyles();
    const history = useHistory();
    const planEatUserContext = React.useContext(PlanEatUserContext);

    const hiddeLink = (requiredRole: String) => {
        var isHidden = true;
        var user_groups : string[] = []
        let groups = localStorage.getItem("groups")
        if(groups !== null){
            user_groups = groups.split(",")
        }

        user_groups.forEach((user_group) => {
            if(user_group=== requiredRole){
                isHidden = false;
            }
        })

        return isHidden;
    }

    const postLogout = async () => {
        var token = localStorage.getItem('token');
        if(token){ 
            if(planEatUserContext?.planEatServiceUser){
                await planEatApi.postLogout(planEatUserContext?.planEatServiceUser.content.id)
                .then((response) =>{
                    localStorage.clear();
                    history.push("/")
                })
                .catch((e) => {
                    localStorage.clear();
                    console.log(e)
                    history.push("/")
                })
            }
        }
    }

    return (
        <Drawer
            anchor='right'
            open={open}
        >
            <div className={classes.container}>
                <div>
                    <div className={classes.closeIconStyle}>
                        <IconButton onClick={() => { setOpen(false) }} style={{padding: 0}}>
                            <MdClose fontSize="large" />
                        </IconButton>
                    </div>
                    <div className={classes.sideNavContainer}>
                        <div className={classes.menuItem}>
                            <Link onClick={() => { history.push('booking') }} className={classes.menuItemText}>
                               Booking
                            </Link>
                        </div>
                        <div className={classes.menuItem}>
                            <Link onClick={() => { history.push('profile') }} className={classes.menuItemText}>
                                Profile
                            </Link>
                        </div>
                        <div className={classes.menuItem} hidden={hiddeLink("eater_group_admin_users")}>
                            <Link onClick={() => { history.push('eaterGroupAdmin') }} className={classes.menuItemText}>
                                Admin Panel
                            </Link>
                        </div>
                    </div>
                </div>
                <div className={classes.oneItemRow}>
                    <div className={classes.buttonContainer} onClick={() => postLogout()}>
                        <div className={classes.logoutText}>
                            Log out
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}
